import { splitLocale } from '../../locale/localeUtils';
export const fontWeightTokens = () => ({
  normal: '400',
  bold: '600',
  default: '400',
  thick: '600',
  thin: '300'
});
export const fontWeightTokensNova = language => {
  // Split out the language as font weight differs in some locales
  const {
    lang
  } = splitLocale(language);
  switch (lang) {
    case 'ar':
    case 'zh':
    case 'ja':
    case 'ko':
    case 'th':
      return {
        normal: '400',
        bold: '700',
        default: '400',
        thick: '700',
        thin: '400'
      };
    default:
      return {
        normal: '400',
        bold: '700',
        default: '400',
        thick: '700',
        thin: '300'
      };
  }
};
//# sourceMappingURL=fontWeight.js.map